import React from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/committees.webp";

const Committees = () => {
    const committees = {
        "Examination Committee": [
            {
                title: "Examination Committee",
                members: [
                    { name: "Dr. B. P. Bhol", designation: "Member" },
                    { name: "Dr. Rani Jha", designation: "Member" },
                    { name: "Dr. Garima Diwan", designation: "Member" },
                    { name: "Dr. N. Kumar Swamy", designation: "Member" },
                    { name: "Mr. Takeshwar Kaushik", designation: "Member" },
                    { name: "Mr. Govinda Sahu", designation: "Member" },
                    { name: "Dr. Poonam Verma", designation: "Member" },
                    { name: "Mr. Rajendra Prasad Gendre", designation: "Member" },
                    { name: "Ms. Vimla Sona", designation: "Member" },
                    { name: "Mr. Yugal Kishor Rajput", designation: "Member" },
                    { name: "Mrs. Keshar Lata Sahu", designation: "Member" }
                ]
            }
        ],
        "Discipline Committee": [
            {
                title: "Discipline Committee",
                members: [
                    { name: "Dr. Gokul Prasad Sahu", designation: "Member" },
                    { name: "Mr. Sidharth Mishra", designation: "Member" },
                    { name: "Mr. Sanjiv Jangde", designation: "Member" },
                    { name: "Mr. Hemant Pandey", designation: "Member" },
                    { name: "Ms. Lukeshwari Verma", designation: "Member" },
                    { name: "Ms. Lalita Sahu", designation: "Member" }
                ]
            }
        ],
        "Training, Placement and Entrepreneurship Committee": [
            {
                title: "Training, Placement and Entrepreneurship Committee",
                members: [
                    { name: "Dr. Rani Jha", designation: "Member" },
                    { name: "Dr. Poonam Verma", designation: "Member" },
                    { name: "Dr. Garima Diwan", designation: "Member" },
                    { name: "Mr. Khemanshu Kumar Sahu", designation: "Member" }
                ]
            }
        ],
        "Hostel Committee": [
            {
                title: "Hostel Committee",
                members: [
                    { name: "Mr. Arjun Singh", designation: "Member" },
                    { name: "Mr. Gaurav Kumar", designation: "Member" },
                    { name: "Dr. Poonam Verma", designation: "Member" },
                    { name: "Dr. Ram Krishna Deshmukh", designation: "Member" }
                ]
            }
        ],
        "Health and Hygiene Committee": [
            {
                title: "Health and Hygiene Committee",
                members: [
                    { name: "Dr. Garima Diwan", designation: "Member" },
                    { name: "Mr. Yugal Kishor Rajput", designation: "Member" },
                    { name: "Mr. Rajendra Kumar Sahu", designation: "Member" },
                    { name: "Mr. Ashwanee Kumar Sahu", designation: "Member" },
                    { name: "Ms. Lukeshwari Verma", designation: "Member" }
                ]
            }
        ],
        "NCC & NSS Committees": [
            {
                title: "NCC & NSS Committees",
                members: [
                    { name: "Dr. Gokul Prasad Sahu", designation: "Member" },
                    { name: "Dr. Preetam Sahu", designation: "Member" },
                    { name: "Mr. Pukhraj Yadav", designation: "Member" },
                    { name: "Ms. Vimla Sona", designation: "Member" },
                    { name: "Mr. Ashwani Kumar Sahu", designation: "Member" }
                ]
            }
        ],
        "Anti Ragging Committee": [
            {
                title: "Anti Ragging Committee",
                members: [
                    { name: "Prof. (Dr) Anand Mahalwar", designation: "Chairman" },
                    { name: "Dr. B. P. Bhol", designation: "Registrar" },
                    { name: "Dr. Sandeep Kumar", designation: "DSW, Member" },
                    { name: "Dr. N. Kumar Swamy", designation: "ARC, Member" },
                    { name: "Mr. Rajendra Prasad Gendre", designation: "ARC, Member" },
                    { name: "Ms. Poonam Rajput", designation: "ARC, Member" },
                    { name: "Mr. Ramkrishna Deshmukh", designation: "Hostel Warden (Boys)" },
                    { name: "Smt. Kesharlata Sahu", designation: "Hostel Warden (Girls)" },
                    { name: "TI, Chhura", designation: "Member representative of Police Admin" },
                    { name: "Mr. Yashwant Yadaw (Media)", designation: "Member Local Media" },
                    { name: "Mr. Sheetal Dhruw (NGO)", designation: "Member NGO" },
                    { name: "Mr. Pukhraj Yadaw", designation: "Member Non teaching" },
                    { name: "Mr. Arjun Singh", designation: "Member (Administration)" },
                    { name: "Mr. Purshottam", designation: "Member Parents" },
                    { name: "Mr. Mahesh Kumar Sahu", designation: "Member Parents" },
                    { name: "Mr. Jaykumar", designation: "Member Student – Fresher’s" },
                    { name: "Monika Yadu", designation: "Member Student – Fresher’s" },
                    { name: "Kishan Dewangan", designation: "Member Senior Student" },
                    { name: "Harsh Yadu", designation: "Member Senior Student" }
                ]
            }
        ],
        "ST/SC Committee": [
            {
                title: "ST/SC Committee",
                members: [
                    { name: "Dr. Anand Mahalwar, Vice-Chancellor", designation: "Chairman" },
                    { name: "Dr. N. Kumar Swamy, Dean Academics", designation: "Member" },
                    { name: "Dr. Sandeep Sahu, Dean of Student Affairs", designation: "Member" },
                    { name: "Mr. Sanjeev Jandge, Asst. Prof.", designation: "Member" },
                    { name: "Mr. Rajendra Prasad Gendre, Asst. Prof", designation: "Member" },
                    { name: "Ms. Vimla Sona, Asst. Prof.", designation: "Member" },
                    { name: "Mr. Mohit Ram Chelak, Asst. Prof.", designation: "Member" },
                    { name: "Ms. Lukeshwari Verma, Asst. Prof.", designation: "Member" },
                    { name: "Mr. Vagesh Kumbhakar, Asst. Prof.", designation: "Member" },
                    { name: "Dr. Barada Prasad Bhol, Registrar", designation: "Member Secretary" }
                ]
            }
        ],
        "Other Backward Class Committee": [
            {
                title: "Other Backward Class Committee",
                members: [
                    { name: "Dr. Sandeep Sahu, DSW", designation: "Convener" },
                    { name: "Dr. N.K Swamy, Director IQAC", designation: "Member Secretary" },
                    { name: "Dr. Preetam Sahu, Asst. Prof. Faculty of Arts & Humanities", designation: "Member" },
                    { name: "Dr. Gokul Prasad Sahu, Asst. Prof. Faculty of Science", designation: "Member" },
                    { name: "Dr. Garima Diwan, Associate Prof. Faculty of Arts & Humanities", designation: "Member" },
                    { name: "Dr. Poonam Verma, Asst. Prof. Faculty of Science", designation: "Member" },
                    { name: "Mr. Rameshwar Nishad, Asst. Prof. Faculty of Science", designation: "Liaison officer for OBC Cell (nominated by Vice Chancellor)" },
                    { name: "Dr. Ram Krishna Deshmukh, Asst. Prof. Faculty of Science", designation: "Liaison officer for OBC Cell (nominated by Vice Chancellor)" },
                ]
            }
        ],
        "Student Counselling Committee": [
            {
                title: "Student Counselling Committee",
                members: [
                    { name: "Dr. Barada Prasad Bhol", designation: "Registrar, ISBM University" },
                    { name: "Dr. N. Kumar Swamy", designation: "Dean Academics, ISBM University" },
                    { name: "Dr. Garima Diwan", designation: "Faculty of Arts & Humanities" },
                    { name: "Dr. Abha Tamrakar", designation: "Faculty of Information Technology" },
                    { name: "Dr. Samata Jain", designation: "Faculty of Commerce & Management" },
                    { name: "Dr. Poonam Verma", designation: "Faculty of Science" },
                    { name: "Ms. Vimla Sona", designation: "Faculty of Library & Information Science" },
                    { name: "Mr. Yugal Kishor Rajput", designation: "Faculty of Pharmacy" },
                    { name: "Mr. Rajendra Kumar Gendre", designation: "Faculty of Law" },
                    { name: "Mr. Khemchand Sahu", designation: "Student Representative (BA)" },
                    { name: "Mr. Chanchal", designation: "Student Representative (B.Sc)" },
                    { name: "Mr. Ishwar Singh", designation: "Student Representative (M.Sc)" },
                    { name: "Mr. Harsh Choudhari", designation: "Student Representative" }
                ]
            }
        ],
        "Internal Committee": [
            {
                title: "Internal Committee",
                members: [
                    { name: "Dr. N. Kumar Swamy", designation: "Principal" },
                    { name: "Mr. Takeshwar Kaushik", designation: "Member of faculty" },
                    { name: "Mr. Khemanshu Sahu", designation: "Member of faculty" },
                    { name: "Mr. Chhannu Thakur", designation: "Non-teaching staff" },
                    { name: "Mr. Raghvendra", designation: "Non-teaching staff" },
                    { name: "Mr. Gautam", designation: "Students" },
                    { name: "Mr. Rupendra", designation: "Students" },
                    { name: "Ms. Moksha Rani Sahu", designation: "Students" }
                ]
            }
        ],
        "Internal Complaints Committee under the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013": [
            {
                title: "Internal Complaints Committee under the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013",
                members: [
                    { name: "Dr. Garima Diwan", designation: "Chairperson" },
                    { name: "Mr. Rajendra Prasad Gendre", designation: "Member" },
                    { name: "Mr. Ashwani Kumar Sahu", designation: "Member" },
                    { name: "Mrs. Rameshwari Yadaw", designation: "Member" },
                    { name: "Ms. Saniya Dhruw", designation: "Member" },
                    { name: "Ms. Anju", designation: "Member" }
                ]
            }
        ],
        "Sport Committee": [
            {
                title: "Sport Committee",
                members: [
                    { name: "Mr. Ashwani Kumar Sahu", designation: "Asst. Prof. School of Arts & Humanities" },
                    { name: "Dr. Gokul Prasad", designation: "Asst. Prof. School of Science" },
                    { name: "Mr. Hemant Pandey", designation: "Asst. Prof. School of Science" },
                    { name: "Mr. Dusyant Yadav", designation: "Asst. Prof. School of Engineering & Technology" },
                    { name: "Ms. Ranu Verma", designation: "Asst. Prof. School of Science" },
                    { name: "Ms. Rekha Sahu", designation: "Asst. Prof. School of Science" },
                    { name: "Mr. Chandramani Sahu", designation: "Asst. Prof. School of IT" },
                    { name: "Mr. Sanjiv Jangde", designation: "Asst. Prof. School of Engineering & Technology" }
                ]
            }
        ],
        "Cultural Committee": [
            {
                title: "Cultural Committee",
                members: [
                    { name: "Ms. Vimla Sona", designation: "Asst. Prof. School of Library & Information Science" },
                    { name: "Mr. Preetam", designation: "Asst. Prof. School of Arts & Humanities" },
                    { name: "Ms. Poonam Rajput", designation: "Asst. Prof. School of Pharmacy" },
                    { name: "Mr. Pukhraj Yadav", designation: "Asst. Librarian" },
                    { name: "Ms. Lalita Sahu", designation: "Asst. Prof. School of Science" },
                    { name: "Mr. Rajendra Kumar Sahu", designation: "Asst. Prof. School of Pharmacy" },
                    { name: "Ms. Gaytri", designation: "Student Member (M.Sc)" },
                    { name: "Mr. Akash Barai", designation: "Student Member (BBA LLB)" },
                    { name: "Mr. Ved Prakash", designation: "Student Member (B.Pharma)" }
                ]
            }
        ],
        "Gender Sensitization Cell": [
            {
                title: "Gender Sensitization Cell",
                members: [
                    { name: "Dr. Garima Diwan", designation: "Presiding Officer" },
                    { name: "Ms. Khusboo Rajpoot", designation: "Member" },
                    { name: "Dr. Poonam Verma", designation: "Member" },
                    { name: "Ms. Rekha Sahu", designation: "Member" },
                    { name: "Mrs. Nimmi Sahu", designation: "Member" },
                    { name: "Harsh Yadu (BA)", designation: "Member" },
                    { name: "Prasant Yadaw (B.Com)", designation: "Member" },
                    { name: "Sohendra Sahu (B.Sc)", designation: "Member" }
                ]
            }
        ],
        "STUDENTS' GRIEVANCE REDRESSAL COMMITTEE": [
            {
                title: "STUDENTS' GRIEVANCE REDRESSAL COMMITTEE",
                members: [
                    { name: "Dr. Bhupendra Kumar", designation: "Chairperson, DSW" },
                    { name: "Dr. Garima Diwan", designation: "HOD SO&AH" },
                    { name: "Mr. Rajendra Kumar Gendre", designation: "Member HOD Law" },
                    { name: "Dr. Poonam Verma", designation: "Member HOD SOS" },
                    { name: "Ms. Vimla Sona", designation: "Member HOD SOL& I" },
                    { name: "Mr. Bhagwan Singh", designation: "Student Member" }
                ]
            }
        ]
    };

    return (
        <>
            <title>ISBM University Communities | Connect, Collaborate & Grow</title>
            <meta
                name="description"
                content="Join ISBM University's diverse communities, fostering academic collaboration, networking, and holistic student development in a vibrant learning environment."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content text-center">
                            <h1>Committees</h1>
                            <ol className="breadcrumb mt-3 justify-content-center">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>Home</a>
                                </li>
                                <li className="breadcrumb-item active text-white" aria-current="page">Committees</li>
                                <div className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="committees-section ptb-50">
                <div className="container-xxl">
                    <h2 className="section-title text-center modern-title text-blue">University Committees</h2>
                    <div className="other" id="committeeAccordion">
                        {Object.entries(committees).map(([key, committeeArr], index) => (
                            <div className="other-item mb-3" key={index}>
                                <h2 className="other-header" id={`heading-${index}`}>
                                    <button
                                        className={`other-button fw-bold bg-primary-custom shadow ${index !== 0 ? "collapsed" : ""}`}
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse-${index}`}
                                        aria-expanded={index === 0 ? "true" : "false"}
                                        aria-controls={`collapse-${index}`}
                                    >
                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <span className="committee-title">{key}</span>
                                            <i className={`bi ${index === 0 ? "bi-chevron-up" : "bi-chevron-down"} toggle-icon`}></i>
                                        </div>
                                    </button>
                                </h2>
                                <div
                                    id={`collapse-${index}`}
                                    className={`other-collapse collapse ${index === 0 ? "show" : ""}`}
                                    aria-labelledby={`heading-${index}`}
                                    data-bs-parent="#committeeAccordion"
                                >
                                    <div className="other-body p-0">
                                        <table className="table table-bordered mb-0">
                                            <thead className="bg-light">
                                                <tr>
                                                    <th>Name of Member</th>
                                                    <th>Designation</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {committeeArr[0].members.map((member, idx) => (
                                                    <tr key={idx}>
                                                        <td>{member.name}</td>
                                                        <td>{member.designation}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Committees;
